// extracted by mini-css-extract-plugin
export var fadeIn = "_e5-1";
export var modalContent = "_e5-3";
export var overlay = "_e5-0";
export var popoverContent = "_e5-2";
export var results = "_e5-5";
export var searchInputWrapper = "_e5-4";